import React from 'react';
import { format } from 'react-string-format';
import * as ReactDOM from "react-dom";
import Game from "./Game";
import {NavLink} from "react-router-dom";
import {withRouter} from "./withRouter";
import Subscriptions from "./Subscribe/Subscriptions";
import Subscribers from "./Subscribe/Subscribers";
import {Col, Container, Row, Tabs} from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import ManageGameGeneral from "./ManageGame/ManageGameGeneral";

class ManageCompany extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            teamMembers: [],
            isLoadedTeamMembers: false,
            item: {}
        };
    }

    componentDidMount() {
        console.log(JSON.stringify(this.props));

        fetch(process.env.REACT_APP_API_URL + "/publisher/company/" + this.props.companyId.toString() + "/stats", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        item: result
                    });
                },

                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )

        fetch(process.env.REACT_APP_API_URL + "/publisher/company/" + this.props.companyId.toString() + "/team", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoadedTeamMembers: true,
                        teamMembers: result.team_members
                    });
                },

                (error) => {
                    this.setState({
                        isLoadedTeamMembers: true,
                        error
                    });
                }
            )
    }

    handleSubmit(e) {
        e.preventDefault();

        //TODO: implement subscribe/unsubscribe
    }

    inviteTeamMember(e){
        e.preventDefault();

        const body = {
            "email": e.target.new_team_member_email.value
        };

        fetch(process.env.REACT_APP_API_URL + "/publisher/company/" + this.props.companyId.toString() + "/team/team-member", {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoadedTeamMembers: true,
                        teamMembers: result.team_members
                    });
                },

                (error) => {
                    this.setState({
                        isLoadedTeamMembers: true,
                        error
                    });
                }
            )

        e.target.new_team_member_email.value = "";
    }

    render() {
        const { error, isLoaded, item, teamMembers, isLoadedTeamMembers } = this.state;

        let content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if (!isLoaded) {
            content = <div>Loading...</div>;
        } else {
            content = (
                <div class="alert alert-outline-primary" id="root">
                    <div class={{
                        width: "auto"
                    }}>
                    <div class="row">
                    <div className="col-lg-8">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card mb-md-0">
                                <div className="card-body">
                        <div style={{
                            overflowX: "auto",
                            width: "100%",
                            whiteSpace: "nowrap"
                        }} className="table-responsive">
                            <table className="table table-striped table-hover">
                                <caption>List of apps {item.company.type_full
                                    ? ""
                                    : "- " + (5 - (item.company.games ? item.company.games.length : 0) + " slots remains")}
                                </caption>
                                <thead className="thead-light">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Category</th>
                                    <th scope="col">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {item.company.games.map(game => (
                                    <tr id={game.id.toString()}>
                                        <th scope="row">{item.company.name}-{game.id}</th>
                                        <td>{game.name}</td>
                                        <td>{game.game_category ? game.game_category.name : "None"}</td>
                                        <td>
                                            <NavLink
                                                to={"/games/" + game.id.toString()}
                                                className="btn btn-outline-primary"
                                            >
                                                Open
                                            </NavLink>

                                            <NavLink to={{
                                                pathname: 'game/' + game.id.toString(),
                                                state: {gameId: game.id},
                                            }} className="btn btn-outline-dark"
                                                     style={{
                                                         marginLeft: 15
                                                     }}
                                            >
                                                Manage
                                            </NavLink>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>
                    </div>
                    <br/>
                    {(item.company.games ? item.company.games.length : 0 ) < 5 ? <NavLink to={{
                        pathname: 'game/create',
                        state: {companyId: this.props.companyId},
                    }} className="btn btn-primary">
                        Create app
                    </NavLink> : <empty/>}
                    <hr style={{
                        opacity: 0.1,
                        backgroundColor: "black",
                        height: 4,
                        borderRadius: 5
                    }}/>
                    <h1>{item.company.name}
                        <span width="30px"></span>
                        <NavLink to={{
                            pathname: 'update',
                            state: {companyId: this.props.companyId},
                        }} style={{
                            marginLeft: 15
                        }}>
                            <img src="https://icon-library.com/images/edit-icon-vector/edit-icon-vector-21.jpg" width="30"/>
                        </NavLink>
                    </h1>
                    <h3>
                        <a class="link-info" href={item.company.site}>Site</a>
                        <i style={{
                            marginLeft: 30,
                            fontSize: 16
                        }}>
                            {item.company.phone_number}
                        </i>
                    </h3>
                    <br/>
                    <div class="row">
                        <div class="col-sm-1">
                            <img width="35" src="https://www.freeiconspng.com/uploads/downloads-icon-15.png"/>
                            <span style={{fontSize: 20}}>{item.downloads}</span>
                        </div>

                        <div class="col-sm-1">
                            <img width="35" src="https://www.pngall.com/wp-content/uploads/3/Heart-PNG-Photo-Image.png"/>
                            {
                                item.likes_percentage > -1 ?
                                    <span style={{fontSize: 20}}>{item.likes_percentage}%</span>
                                    :<span></span>
                            }
                        </div>

                        <div class="col-sm-1">
                            <img width="35" src="https://www.pngkey.com/png/full/73-730394_admin-approved-user-registration-user-registration-icon-png.png"/>
                            <span style={{fontSize: 20}}>{item.subscriptions}</span>
                        </div>
                    </div>

                    <br/>
                    <br/>
                    <Tabs
                        defaultActiveKey="general"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                    >
                        <Tab eventKey="general" title="General">
                            <p>{item.company.type_full ? <h2>Premium version</h2> : ""}{item.company.description}</p>

                            <div class="row">
                                {item.company.address ? <div className="col-sm-2 card" style={{width: "12rem"}}>
                                    <img className="card-img-top" src="https://cdn-icons-png.flaticon.com/512/854/854952.png"
                                         alt="Card image cap"/>
                                    <div className="card-body">
                                        <p className="card-text">{item.company.address.line1}</p>
                                    </div>
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item">{item.company.address.postal_code}</li>
                                        <li className="list-group-item">{item.company.address.city}</li>
                                        <li className="list-group-item">{item.company.address.state}</li>
                                        <li className="list-group-item">{item.company.address.country}</li>
                                    </ul>
                                </div> : <span></span>}

                                <div style={{marginLeft: 15}} class="alert alert-dark col-sm">
                                    <button className="btn btn-outline-dark" id='subscribers-button' onClick={(e) => {
                                        let block = document.getElementById('subscribers');

                                        if (block.style.display === 'none') {
                                            block.style.display = 'block';
                                        } else {
                                            block.style.display = 'none';
                                        }
                                    }}>Subscribers
                                    </button>
                                    <div style={{
                                        display: 'none',
                                        marginLeft: 15,
                                        width: 400
                                    }} id='subscribers'>
                                        <Subscribers subscribers={item.subscribers}/>
                                    </div>
                                </div>
                            </div>
                        </Tab>

                    {/*<form onSubmit={this.handleSubmit}>
                        <input type="submit" value="Subscribe"/>
                    </form>*/}
                        <Tab eventKey="team" title="Team">
                            <div style={{
                                width: "100%"
                            }} class="row col-sm-10 alert alert-dark">
                                <h3>Your team:</h3>
                                <form className="col-sm-3 form-inline" onSubmit={this.inviteTeamMember.bind(this)}>
                                    <div className="form-group mb-2">
                                        <input type="email" name="new_team_member_email" className="form-control" placeholder="Email" id="staticEmail2"/>
                                    </div>
                                    <button type="submit" className="btn btn-primary mb-2">Invite</button>
                                </form>
                                <br/>

                                <div align="right" style={{
                                    float: "right",
                                    alignContent: "right",
                                    alignSelf: "right"
                                }} class="alert alert-dark col-sm">
                                    {teamMembers.map(user => (
                                        <div class="row" id={user.id}>
                                            <div class="col-sm">
                                                <NavLink to={{
                                                    pathname: '/customer/' + user.id.toString(),
                                                }} style={{
                                                    color: "black",
                                                    textDecoration: "none"
                                                }}>
                                                    <p>{user.first_name} {user.last_name}, {user.email}</p>
                                                </NavLink>
                                            </div>
                                            <div class="col-sm">
                                                <form onSubmit={(e) => {
                                                    e.preventDefault();

                                                    const body = {
                                                        "email": user.email
                                                    };

                                                    fetch(process.env.REACT_APP_API_URL + "/publisher/company/" + this.props.companyId.toString() + "/team/team-member", {
                                                        method: "DELETE",
                                                        body: JSON.stringify(body),
                                                        headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
                                                    })
                                                        .then(res => res.json())
                                                        .then(
                                                            (result) => {
                                                                this.setState({
                                                                    isLoadedTeamMembers: true,
                                                                    teamMembers: result.team_members
                                                                });
                                                            },

                                                            (error) => {
                                                                this.setState({
                                                                    isLoadedTeamMembers: true,
                                                                    error
                                                                });
                                                            }
                                                        )
                                                }}>
                                                    <input class="btn btn-danger" type="submit" value="Remove"/>
                                                </form>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            );
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>;
    }
}

export default withRouter(ManageCompany);

